'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Chart = require('./Chart.css');

var _Chart2 = _interopRequireDefault(_Chart);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactChartjs = require('react-chartjs');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chartOptions = {
  segmentStrokeWidth: 0,
  percentageInnerCutout: 70,
  animationEasing: 'easeOutQuad',
  // String - Template string for single tooltips
  tooltipTemplate: "<%if (label){%><%=label %> <%}%><%= value + ' %' %>",
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>"
};

var Chart = (_dec = (0, _reactCssModules2.default)(_Chart2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Chart, _Component);

  function Chart(props) {
    (0, _classCallCheck3.default)(this, Chart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).call(this, props));

    _this.clickViewCategory = function (catName, val) {
      if (_this.state.active === catName || val === 0) {
        _this.setState({ active: 'default' });
      } else {
        _this.setState({ active: catName });
      }
    };

    _this.formatWeight = function (el) {
      var weight = _this.props.fHoldingsMap[el.id].scaled_weighting;
      var formattedWeight = Math.round(weight * 100 * 100) / 100;
      return formattedWeight;
    };

    _this.getChartData = function (famType, dffPerc, producerPerc, bankPerc, consumerPerc, producerHoldings, financierHoldings, consumerHoldings) {
      var chartData = [];

      var clrs = {
        redorange: '#DE450A',
        orange: '#F2961C',
        yellow: '#DFB553',
        gray: '#D5D5D5',
        black: '#333333'
      };

      var cleanItem = {
        value: 100,
        label: 'Other',
        color: clrs.gray // gray
      };

      var dfDiff = 100.0 - Math.round(dffPerc * 100) / 100;
      var pDiff = 100.0 - Math.round(producerPerc * 100) / 100;
      var fDiff = 100.0 - Math.round(bankPerc * 100) / 100;
      var cDiff = 100.0 - Math.round(consumerPerc * 100) / 100;

      if (_this.state.active === 'default') {
        if (dffPerc === 0) {
          chartData.push(cleanItem);
        } else {
          chartData.push({
            value: dffPerc,
            label: 'Deforestation-risk holdings',
            color: clrs.black
          });
          chartData.push({
            value: dfDiff,
            label: 'Other',
            color: clrs.gray
          });
        }
      } else if (_this.state.active === 'producers') {
        if (producerPerc === 0) {
          chartData.push(cleanItem);
        } else {
          if (famType) {
            chartData.push({
              value: producerPerc,
              label: 'Commodity producers',
              color: clrs.redorange
            });
            chartData.push({
              value: pDiff,
              label: 'Other',
              color: clrs.gray
            });
          } else {
            chartData = producerHoldings.map(function (el, ix) {
              return {
                value: _this.formatWeight(el),
                label: el.security_name,
                color: clrs.redorange
              };
            });
          }
        }
      } else if (_this.state.active === 'banks') {
        if (bankPerc === 0) {
          chartData.push(cleanItem);
        } else {
          if (famType) {
            chartData.push({
              value: bankPerc,
              label: 'Banks and lenders',
              color: clrs.orange
            });
            chartData.push({
              value: fDiff,
              label: 'Other',
              color: clrs.gray
            });
          } else {
            chartData = financierHoldings.map(function (el, ix) {
              return {
                value: _this.formatWeight(el),
                label: el.security_name,
                color: clrs.orange
              };
            });
          }
        }
      } else if (_this.state.active === 'consumers') {
        if (consumerPerc === 0) {
          chartData.push(cleanItem);
        } else {
          if (famType) {
            chartData.push({
              value: consumerPerc,
              label: 'Major consumer brands',
              color: clrs.yellow
            });
            chartData.push({
              value: cDiff,
              label: 'Other',
              color: clrs.gray
            });
          } else {
            chartData = consumerHoldings.map(function (el, ix) {
              return {
                value: _this.formatWeight(el),
                label: el.security_name,
                color: clrs.yellow
              };
            });
          }
        }
      }
      return chartData;
    };

    _this.state = {
      active: 'default'
    };
    return _this;
  }

  (0, _createClass3.default)(Chart, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          famType = _props.famType,
          dffPerc = _props.dffPerc,
          producerPerc = _props.producerPerc,
          bankPerc = _props.bankPerc,
          consumerPerc = _props.consumerPerc,
          producerHoldings = _props.producerHoldings,
          financierHoldings = _props.financierHoldings,
          consumerHoldings = _props.consumerHoldings;


      var chartData = this.getChartData(famType, dffPerc, producerPerc, bankPerc, consumerPerc, producerHoldings, financierHoldings, consumerHoldings);

      var producersIcon = require('../../../static/images/icn-producers.svg');
      var banksIcon = require('../../../static/images/icn-banks.svg');
      var consumersIcon = require('../../../static/images/icn-consumers.svg');

      var producersInactiveIcon = require('../../../static/images/icn-producers-g.svg');
      var banksInactiveIcon = require('../../../static/images/icn-banks-g.svg');
      var consumersInactiveIcon = require('../../../static/images/icn-consumers-g.svg');

      var pIcon = producerPerc === 0 ? producersInactiveIcon : producersIcon;
      var fIcon = bankPerc === 0 ? banksInactiveIcon : banksIcon;
      var cIcon = consumerPerc === 0 ? consumersInactiveIcon : consumersIcon;

      var producersStyle = producerPerc === 0 ? 'blank-label' : this.state.active === 'producers' ? 'producers-label-actv' : 'producers-label';

      var banksStyle = bankPerc === 0 ? 'blank-label' : this.state.active === 'banks' ? 'banks-label-actv' : 'banks-label';

      var consumerStyle = consumerPerc === 0 ? 'blank-label' : this.state.active === 'consumers' ? 'consumers-label-actv' : 'consumers-label';

      return _react2.default.createElement(
        'div',
        { styleName: 'grade-chart-wrapper' },
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          { styleName: 'grade-chart' },
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 6, md: 4, styleName: 'box' },
            this.props.renderBox()
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 6, md: 4, styleName: 'chart' },
            this.state.active === 'default' ? _react2.default.createElement(_reactChartjs.Doughnut, {
              data: chartData,
              options: chartOptions,
              width: '300',
              height: '300'
            }) : null,
            this.state.active === 'producers' ? _react2.default.createElement(_reactChartjs.Doughnut, {
              data: chartData,
              options: chartOptions,
              width: '300',
              height: '300'
            }) : null,
            this.state.active === 'banks' ? _react2.default.createElement(_reactChartjs.Doughnut, {
              data: chartData,
              options: chartOptions,
              width: '300',
              height: '300'
            }) : null,
            this.state.active === 'consumers' ? _react2.default.createElement(_reactChartjs.Doughnut, {
              data: chartData,
              options: chartOptions,
              width: '300',
              height: '300'
            }) : null,
            _react2.default.createElement(
              'div',
              { styleName: 'chart-details' },
              _react2.default.createElement(
                'div',
                { styleName: 'chart-assets' },
                this.state.active === 'producers' ? producerPerc + '%' : null,
                this.state.active === 'banks' ? bankPerc + '%' : null,
                this.state.active === 'consumers' ? consumerPerc + '%' : null,
                this.state.active === 'default' ? dffPerc + '%' : null
              ),
              _react2.default.createElement(
                'div',
                null,
                'INVESTED IN',
                this.state.active === 'producers' ? ' AGRIBUSINESS PRODUCERS AND TRADERS' : null,
                this.state.active === 'banks' ? ' BANKS AND LENDERS' : null,
                this.state.active === 'consumers' ? ' MAJOR CONSUMER BRANDS' : null,
                this.state.active === 'default' ? ' DEFORESTATION-RISK COMPANIES' : null
              )
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 12, md: 4, styleName: 'labels' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'producers',
                onClick: function onClick() {
                  _this2.clickViewCategory('producers', producerPerc);
                }
              },
              _react2.default.createElement('img', { styleName: 'po-icon', src: pIcon, alt: 'producers' }),
              _react2.default.createElement(
                'div',
                { styleName: producersStyle },
                _react2.default.createElement(
                  'div',
                  { styleName: 'title' },
                  'AGRIBUSINESS'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'intro' },
                  'deforestation-risk producers and traders of palm oil, paper/pulp, rubber, timber, cattle, and soy'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                styleName: 'banks',
                onClick: function onClick() {
                  _this2.clickViewCategory('banks', bankPerc);
                }
              },
              _react2.default.createElement('img', { styleName: 'po-icon', src: fIcon, alt: 'banks' }),
              _react2.default.createElement(
                'div',
                { styleName: banksStyle },
                _react2.default.createElement(
                  'div',
                  { styleName: 'title' },
                  'BANKS AND LENDERS'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'intro' },
                  'that finance deforestation-risk agribusiness producers via lending and underwriting'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                styleName: 'consumers',
                onClick: function onClick() {
                  _this2.clickViewCategory('consumers', consumerPerc);
                }
              },
              _react2.default.createElement('img', { styleName: 'po-icon', src: cIcon, alt: 'consumers' }),
              _react2.default.createElement(
                'div',
                { styleName: consumerStyle },
                _react2.default.createElement(
                  'div',
                  { styleName: 'title' },
                  'MAJOR CONSUMER BRANDS'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'intro' },
                  'that use deforestation-risk agribusiness commodities in products'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Chart;
}(_react.Component), _class2.propTypes = {
  renderBox: _react.PropTypes.func.isRequired,
  currency: _react.PropTypes.string.isRequired,
  invested: _react.PropTypes.number.isRequired,
  consumerPerc: _react.PropTypes.number,
  bankPerc: _react.PropTypes.number,
  producerPerc: _react.PropTypes.number,
  dffPerc: _react.PropTypes.number,
  consumerHoldings: _react.PropTypes.array,
  financierHoldings: _react.PropTypes.array,
  producerHoldings: _react.PropTypes.array,
  fHoldingsMap: _react.PropTypes.object,
  famType: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Chart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/Chart.js
// module id = 1315
// module chunks = 0